// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3fM6f","label":"Radio_label__1Q1zM","checkMark":"Radio_checkMark__3JXRs","disabled":"Radio_disabled__14Am6"};